import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [data, setData] = useState(null); // null=checking, false=guest, {user, org, locations}
  const [locationId, setLocationId] = useState(() => localStorage.getItem("sk_loc") || null);

  const checkAuth = useCallback(async () => {
    try {
      const res = await api.get("/auth/me");
      setData(res.data);
      const locs = res.data.locations || [];
      if (locs.length && !locs.find((l) => l.location_id === localStorage.getItem("sk_loc"))) {
        localStorage.setItem("sk_loc", locs[0].location_id);
        setLocationId(locs[0].location_id);
      }
    } catch {
      setData(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: If returning from OAuth callback, skip the /me check.
    // AuthCallback will exchange the session_id and establish the session first.
    if (window.location.hash?.includes("session_id=")) {
      setData(null);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const selectLocation = useCallback((id) => {
    localStorage.setItem("sk_loc", id);
    setLocationId(id);
  }, []);

  const logout = useCallback(async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("sk_loc");
    setData(false);
  }, []);

  return (
    <AuthContext.Provider value={{ data, setData, checkAuth, logout, locationId, selectLocation }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

export function useUser() {
  const ctx = useContext(AuthContext);
  return ctx?.data && ctx.data !== false ? ctx.data.user : null;
}
